import { SaveAs } from '@mui/icons-material'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

function EditO() {
    const { ID } = useParams();
    const navigate = useNavigate();
    const {profile} = useContext(AuthContext);
    const [order, setOrder] = useState({});
    const [loading, setLoading] = useState(true);
    const handleInputChange = (e) => {
        console.log(order)
        const { name, value } = e.target;
        setOrder((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSave = async () => {
        try {
            if(order.status >0) {

            }else {
                order.status = 2;
            };
            const response = await fetch('https://elnaf.fi/new/api/editOrder.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(order), // `order` state-dən məlumatları göndər
            });
            const result = await response.json();
            console.log(result);
            if (result.status === 'success') {
                alert('Order updated successfully!');
                navigate('/');
            } else {
                alert('Error: ' + result.message);
            }
        } catch (error) {
            console.error('Error updating order:', error);
        }
    };

    useEffect(() => {
        const fetchOrderDetails = async () => {
            try {
                const response = await fetch(`https://elnaf.fi/new/api/orders.php?id=${ID}`);
                const data = await response.json();
                const updatedOrder = {
                    ...data.orders[0], // mövcud obyektin bütün sahələri
                    username: profile.username, // yeni sahə əlavə olunur
                };
                setOrder(updatedOrder);
            } catch (err) {

            } finally {
                setLoading(false);
            }
        };

        fetchOrderDetails();
        if (!order) {
            navigate('/notFound');
        }
    }, [ID]);
    return (
        <div className="row">
            {ID &&

                <div className="col-xl-12">
                    <div className="card custom-card">
                        <div className="p-3 border-bottom border-top border-block-end-dashed tab-content">
                            <div className="tab-pane show active p-0 border-0" id="account-pane" role="tabpanel" aria-labelledby="account" tabIndex={0}>
                                <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-1">
                                    <div className="fw-semibold d-block fs-15">Order ID : {ID}</div>

                                </div>
                                <div className="row gy-3">
                                    <div className="col-xl-6">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input onChange={handleInputChange} type="text" className="form-control" name="name" placeholder="Name" value={order.name} />
                                    </div>
                                    <div className="col-xl-6">
                                        <label htmlFor="last_name" className="form-label">Last Name</label>
                                        <input onChange={handleInputChange} type="text" className="form-control" name="last_name" placeholder="Last Name" value={order.last_name} />
                                    </div>
                                    <div className="col-xl-6">
                                        <label htmlFor="company" className="form-label">Company</label>
                                        <input onChange={handleInputChange} type="text" className="form-control" name="company" placeholder="Company" value={order.company} />
                                    </div>
                                    <div className="col-xl-6">
                                        <label htmlFor="country_region" className="form-label">Country/Region</label>
                                        <input onChange={handleInputChange} type="text" className="form-control" name="country_region" placeholder="Country/Region" value={order.country_region} />
                                    </div>
                                    <div className="col-xl-6">
                                        <label htmlFor="street_address" className="form-label">Street Address</label>
                                        <input onChange={handleInputChange} type="text" className="form-control" name="street_address" placeholder="Street Address" value={order.street_address} />
                                    </div>
                                    <div className="col-xl-6">
                                        <label htmlFor="town_city" className="form-label">Town/City</label>
                                        <input onChange={handleInputChange} type="text" className="form-control" name="town_city" placeholder="Town/City" value={order.town_city} />
                                    </div>
                                    <div className="col-xl-6">
                                        <label htmlFor="post_code" className="form-label">Post Code</label>
                                        <input onChange={handleInputChange} type="text" className="form-control" name="post_code" placeholder="Post Code" value={order.post_code} />
                                    </div>
                                    <div className="col-xl-6">
                                        <label htmlFor="phone" className="form-label">Phone</label>
                                        <input onChange={handleInputChange} type="text" className="form-control" name="phone" placeholder="Phone" value={order.phone} />
                                    </div>
                                    <div className="col-xl-6">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input onChange={handleInputChange} type="email" className="form-control" name="email" placeholder="Email" value={order.email} />
                                    </div>
                                    <div className="col-xl-6">
                                        <label htmlFor="notes" className="form-label">Notes</label>
                                        <textarea onChange={handleInputChange} className="form-control" name="notes" placeholder="Notes" value={order.notes}></textarea>
                                    </div>
                                    <div className="col-xl-6">
                                        <label htmlFor="products" className="form-label">Products</label>
                                        <textarea onChange={handleInputChange} className="form-control" name="products" placeholder="Products JSON" value={order.products}></textarea>
                                    </div>
                                    <div className="col-xl-6">
                                        <label htmlFor="total" className="form-label">Total</label>
                                        <input onChange={handleInputChange} className="form-control" name="total" placeholder="total" value={order.total}/>
                                    </div>
                                    <div className="col-xl-6">
                                        <label htmlFor="status" className="form-label">Order Status</label>
                                        <select onChange={handleInputChange} value={order.status > 0 ? order.status : 2} className="form-control" data-trigger name="status" >
                                                <option value={1}>Approved</option>
                                                <option value={2}>Pending</option>
                                                <option value={3}>Cancelled</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-footer border-top-0">
                            <div className="btn-list float-end">
                                <button className="btn btn-primary" onClick={handleSave}>Save Order<SaveAs className="bi bi-download ms-2" /></button>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>

    )
}

export default EditO